import React from 'react';
import { X as XIcon } from 'lucide-react';
import { Button } from '../ui/button';
import { useTheme } from '../ThemeProvider';
import { PageWrapper } from '../layout';

// Feature components
import NutritionTracker from '../NutritionTrackerRefactored';
import ProgressPhotos from '../ProgressPhotos';
import Statistics from '../Statistics';
import WalkingCalendar from '../WalkingCalendar';
import AiPlanner from '../AiPlanner';
import WearableIntegrations from '../WearableIntegrations';
import SubscriptionPlans from '../SubscriptionPlans';
import FridgeOracle from '../FridgeOracle';
import WalkingSetup from '../WalkingSetup';
import SocialFeed from '../SocialFeed';
import MedicationReminder from '../features/MedicationReminder';
import DiabetesDiary from '../features/DiabetesDiary';
import HealthCoach from '../features/HealthCoach';

export const CategoryView = ({
  selectedCategory,
  onBack,
  isExpired,
  onNavigate,
  customMealTimes,
  onGoToWalking,
}) => {
  const { theme } = useTheme();

  // Nutrition view
  if (selectedCategory === 'nutrition') {
    return (
      <PageWrapper pageKey="nutrition">
        <NutritionTracker 
          onBack={onBack} 
          isExpired={isExpired} 
          customMealTimes={customMealTimes}
          onNavigate={onNavigate}
        />
      </PageWrapper>
    );
  }

  // Progress Photos view
  if (selectedCategory === 'photos') {
    return (
      <PageWrapper pageKey="photos">
        <ProgressPhotos 
          onBack={onBack} 
          isExpired={isExpired} 
          onNavigate={onNavigate}
        />
      </PageWrapper>
    );
  }

  // Statistics view
  if (selectedCategory === 'statistics') {
    return (
      <PageWrapper pageKey="statistics">
        <Statistics 
          onBack={onBack} 
          isExpired={isExpired}
          onNavigate={onNavigate}
        />
      </PageWrapper>
    );
  }

  // Walking setup view
  if (selectedCategory === 'walking') {
    return (
      <PageWrapper pageKey="walking">
        <WalkingSetup 
          onStartWorkout={(config) => {
            if (onGoToWalking) onGoToWalking(config);
          }}
          onBack={onBack}
          isExpired={isExpired}
          onNavigate={onNavigate}
        />
      </PageWrapper>
    );
  }

  // Calendar view
  if (selectedCategory === 'calendar') {
    return (
      <PageWrapper pageKey="calendar">
        <WalkingCalendar 
          onBack={onBack} 
          isExpired={isExpired}
          onNavigate={onNavigate}
        />
      </PageWrapper>
    );
  }

  // AI Planner view
  if (selectedCategory === 'aiplanner') {
    return (
      <PageWrapper pageKey="aiplanner">
        <AiPlanner 
          onBack={onBack} 
          isExpired={isExpired} 
          onNavigate={onNavigate}
        />
      </PageWrapper>
    );
  }

  // Wearables view
  if (selectedCategory === 'wearables') {
    return (
      <PageWrapper pageKey="wearables">
        <WearableIntegrations onBack={() => { onBack(); onNavigate('personal'); }} />
      </PageWrapper>
    );
  }

  // FridgeOracle view
  if (selectedCategory === 'fridge') {
    return (
      <PageWrapper pageKey="fridge">
        <FridgeOracle onBack={onBack} isExpired={isExpired} onNavigate={onNavigate} />
      </PageWrapper>
    );
  }

  // Community view
  if (selectedCategory === 'community') {
    return (
      <PageWrapper pageKey="community">
        <SocialFeed onBack={onBack} isExpired={isExpired} onNavigate={onNavigate} />
      </PageWrapper>
    );
  }

  // Medications view
  if (selectedCategory === 'medications') {
    return (
      <PageWrapper pageKey="medications">
        <MedicationReminder onBack={onBack} onNavigate={onNavigate} isExpired={isExpired} />
      </PageWrapper>
    );
  }

  // Diabetes Diary view
  if (selectedCategory === 'diabetes') {
    return (
      <PageWrapper pageKey="diabetes">
        <DiabetesDiary onBack={onBack} onNavigate={onNavigate} isExpired={isExpired} />
      </PageWrapper>
    );
  }

  // Health Coach view
  if (selectedCategory === 'healthcoach') {
    return (
      <PageWrapper pageKey="healthcoach">
        <HealthCoach />
      </PageWrapper>
    );
  }

  // Subscription view
  if (selectedCategory === 'subscription') {
    return (
      <PageWrapper pageKey="subscription">
        <div className={`min-h-screen bg-gradient-to-br ${theme.gradient} flex flex-col`}>
          <header className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-lg ${theme.headerBg} border-none ios-header`} style={{ paddingTop: 'max(16px, env(safe-area-inset-top, 16px))', border: 'none' }}>
            <div className="container mx-auto px-4 py-3 flex items-center justify-between">
              <Button variant="ghost" onClick={onBack}>
                <XIcon className="h-5 w-5" />
              </Button>
              <h1 className="text-lg font-bold text-white">Premium Subscription</h1>
              <div className="w-10"></div>
            </div>
          </header>
          <main className="flex-1 container mx-auto px-4 py-6 pb-8 pt-20">
            <SubscriptionPlans onSuccess={onBack} />
          </main>
        </div>
      </PageWrapper>
    );
  }

  // No category selected - return null (home view will be rendered by parent)
  return null;
};

export default CategoryView;
